import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    icon = "icon",
    document = "document",
    displayText = "displayText",
}

interface Props extends WidgetProps {
    fields: {
        [fields.icon]: string;
        [fields.document]: string;
        [fields.displayText]: string;
    };
}

export interface DocumentLinkStyles {
    wrapper?: InjectableCss;
}

export const styles: DocumentLinkStyles = {
    wrapper: {
        css: css`
            display: flex;
        `,
    },
};

const DocumentLink: React.FC<Props> = props => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <Link href={fields.document} target="_blank">
                <Typography color="primary" weight="bold" style={{ flexGrow: 1 }}>
                    {props.fields.displayText}
                </Typography>
                <img src={fields.icon} alt="" width="100%" height="auto" />
            </Link>
        </StyledWrapper>
    );
};

const definition: WidgetDefinition = {
    group: "Testing",
    fieldDefinitions: [
        {
            name: fields.icon,
            displayName: "Icon",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
        },
        {
            name: fields.document,
            displayName: "Document Link",
            fieldType: "Translatable",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isRequired: true,
        },
        {
            name: fields.displayText,
            displayName: "Display Text",
            editorTemplate: "TextField",
            fieldType: "Translatable",
            isRequired: true,
            defaultValue: "",
        },
    ],
};

const widgetModule: WidgetModule = {
    component: DocumentLink,
    definition,
};

export default widgetModule;
